module.exports = __webpack_public_path__ + "img/Global-Learning-XPRIZE.v2.eb0af37a.jpg";